import toast from "react-hot-toast";

const notify = (msg, type) => {
  if (type === "warn") toast(msg, { icon: '⚠️' });
  else if (type === "success") toast.success(msg);
  else if (type === "error") toast.error(msg);
};
export default notify;
